// import {
//   Form,
//   Input,
//   InputNumber,
//   Modal,
//   Select,
//   Row,
//   Col,
//   Switch,
//   Flex,
// } from "antd";
// import { useState, useEffect } from "react";
// import { Infinity } from "lucide-react";

// const PackageForm = ({ visible, onCreate, onCancel, record, businessType }) => {
//   const [form] = Form.useForm();
//   const [selectedBusinessType, setSelectedBusinessType] = useState(null);
//   const [isReferralPer, setIsReferralPer] = useState(true);
//   const [unlimitedFields, setUnlimitedFields] = useState({
//     noOfCompanies: false,
//     noOfEways: false,
//     noOfEInvoice: false,
//     noOfUser: false,
//     noOfWp: false,
//   });

//   // const productOptions = [
//   //   { id: 1, name: "09 TAX" },
//   //   { id: 2, name: "ECOMMGPT" },
//   //   { id: 3, name: "OFFICE CRM" },
//   // ];

//   const dueTypeOptions = [
//     { id: "DAY", name: "Day" },
//     { id: "MONTH", name: "Month" },
//     { id: "YEAR", name: "Year" },
//   ];

//   useEffect(() => {
//     if (record) {

//       const isDemoValue =
//         record.isDemo === true || record.isDemo === 1 || record.isDemo === "1"
//           ? 1
//           : 0;

//       // Set unlimited fields state based on record
//       const unlimitedState = {
//         noOfCompanies: record.noOfCompanies === -100,
//         noOfEways: record.noOfEways === -100,
//         noOfEInvoice: record.noOfEInvoice === -100,
//         noOfUser: record.noOfUser === -100,
//         noOfWp: record.noOfWp === -100,
//       };
//       setUnlimitedFields(unlimitedState);

//       // Prepare form values
//       const formValues = {
//         name: record.name,
//         description: record.description,
//         discPer: record.discPer || null,
//         discAmt: record.discAmt || null,
//         amcPeriod: record.amcPeriod,
//         durType: record.durType,
//         amcPrice: record.amcPrice,
//         detail: record.detail,
//         isDemo: isDemoValue,
//         businessType: record.businessType,
//         product: [1],
//         // Set these to null or empty initially - we'll handle display separately
//         noOfCompanies: unlimitedState.noOfCompanies
//           ? null
//           : record.noOfCompanies,
//         noOfEways: unlimitedState.noOfEways ? null : record.noOfEways,
//         noOfEInvoice: unlimitedState.noOfEInvoice ? null : record.noOfEInvoice,
//         noOfUser: unlimitedState.noOfUser ? null : record.noOfUser,
//         noOfWp: unlimitedState.noOfWp ? null : record.noOfWp,
//         isMobileApp: record.isMobileApp,
//         isCrm: record.isCrm,
//         isRojmel: record.isRojmel,
//         isToDo: record.isToDo,
//         isDailyWp: record.isDailyWp,
//         referralAmt: record.referralAmt,
//         referralPer: record.referralPer,
//         isDashboardGst: record.isDashboardGst,
//         is2a2b: record.is2a2b,
//         is2stepVerify: record.is2stepVerify,
//         sales_challan: record.sales_challan,
//         sales_invoice: record.sales_invoice,
//         purchase_challan: record.purchase_challan,
//         purchase_invoice: record.purchase_invoice,
//         sales_return: record.sales_return,
//         purchase_return: record.purchase_return,
//         issue: record.issue,
//         receive: record.receive,
//         cash: record.cash,
//         bank: record.bank,
//         jv: record.jv,
//         stock_transfer: record.stock_transfer,
//         share_company: record.share_company,
//         company_wise_master: record.company_wise_master,
//         delete_unused_master: record.delete_unused_master,
//         aamne_saamne_sale_purchase: record.aamne_saamne_sale_purchase,
//         multiple_eway_bill_generate: record.multiple_eway_bill_generate,
//         print_barcode: record.print_barcode,
//         sales_order: record.sales_order,
//         purchase_order: record.purchase_order,
//         bank_import: record.bank_import,
//         bulk_update_suspense_account: record.bulk_update_suspense_account,
//       };

//       form.setFieldsValue(formValues);
//       setSelectedBusinessType(record.businessType);
//     } else {
//       form.resetFields();
//       setSelectedBusinessType(null);
//       setUnlimitedFields({
//         noOfCompanies: false,
//         noOfEways: false,
//         noOfEInvoice: false,
//         noOfUser: false,
//         noOfWp: false,
//       });
//     }
//   }, [record, form]);

//   useEffect(() => {
//     if (record) {
//       setUnlimitedFields({
//         noOfCompanies: record.noOfCompanies === -100 ? true : false,
//         noOfEways: record.noOfEways === -100 ? true : false,
//         noOfEInvoice: record.noOfEInvoice === -100 ? true : false,
//         noOfUser: record.noOfUser === -100 ? true : false,
//         noOfWp: record.noOfWp === -100 ? true : false,
//       });
//     }
//   }, [record]);

//   const handleBusinessChange = (value) => {
//     setSelectedBusinessType(value);
//   };

//   const formItemLayout = {
//     labelCol: { span: 24 },
//     wrapperCol: { span: 24 },
//   };

//   return (
//     <Modal
//       open={visible}
//       title={record ? "Update Package" : "Add Package"}
//       okText="Submit"
//       zIndex={10000}
//       cancelText="Cancel"
//       onCancel={() => {
//         form.resetFields();
//         onCancel();
//       }}
//       onOk={() => {
//         form
//           .validateFields()
//           .then((values) => {
//             values.isDemo = values.isDemo === 1 ? true : false;

//             // Handle unlimited fields
//             const fieldMapping = [
//               "noOfCompanies",
//               "noOfEways",
//               "noOfEInvoice",
//               "noOfUser",
//               "noOfWp",
//             ];

//             fieldMapping.forEach((field) => {
//               if (unlimitedFields[field]) {
//                 values[field] = -100;
//               } else if (
//                 values[field] === undefined ||
//                 values[field] === null
//               ) {
//                 // If field is not unlimited but has no value, set to 0 or keep as is
//                 values[field] = 0;
//               }
//             });

//             onCreate(values);

//             // Reset
//             form.resetFields();
//             setUnlimitedFields({
//               noOfCompanies: false,
//               noOfEways: false,
//               noOfEInvoice: false,
//               noOfUser: false,
//               noOfWp: false,
//             });
//           })
//           .catch((info) => {
//             console.error("Validate Failed:", info);
//           });
//       }}
//       width={1200}
//       height={750}
//       centered
//       bodyStyle={{ paddingTop: 20 }}
//     >
//       <Form
//         {...formItemLayout}
//         form={form}
//         layout="vertical"
//         name="package_form"
//       >
//         <Row gutter={24}>
//           <Col span={6}>
//             <Form.Item
//               name="name"
//               label="Name"
//               rules={[
//                 { required: true, message: "Please enter the package name!" },
//               ]}
//             >
//               <Input placeholder="Enter name" />
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="description"
//               label="Description"
//               rules={[
//                 {
//                   required: true,
//                   message: "Please enter the package description!",
//                 },
//               ]}
//             >
//               <Input placeholder="Enter description" />
//             </Form.Item>
//           </Col>

//           {/* <Col span={12}>
//             <Form.Item
//               name="grossAmt"
//               label="Gross Amount"
//               rules={[
//                 { required: true, message: "Please enter the gross amount!" },
//               ]}
//             >
//               <InputNumber
//                 placeholder="Enter amount"
//                 style={{ width: "100%" }}
//               />
//             </Form.Item>
//           </Col> */}
//           <Col span={6}>
//             <Form.Item
//               name="discPer"
//               label="Discount (%)"
//               dependencies={["discAmt"]}
//               rules={[
//                 ({ getFieldValue }) => ({
//                   validator(_, value) {
//                     const discAmt = getFieldValue("discAmt");
//                     if (value != null && discAmt != null) {
//                       return Promise.reject(
//                         new Error("Please enter either percentage OR amount, not both!")
//                       );
//                     }
//                     if (value == null && discAmt == null) {
//                       return Promise.reject(
//                         new Error("Please enter either discount percentage or amount!")
//                       );
//                     }
//                     return Promise.resolve();
//                   },
//                 }),
//                 { type: "number", message: "Must be a valid percentage!" },
//               ]}
//             >
//               <InputNumber placeholder="Enter %" style={{ width: "100%" }} />
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="discAmt"
//               label="Discount Amount"
//               dependencies={["discPer"]}
//               rules={[
//                 ({ getFieldValue }) => ({
//                   validator(_, value) {
//                     const discPer = getFieldValue("discPer");
//                     if (value != null && discPer != null) {
//                       return Promise.reject(
//                         new Error("Please enter either percentage OR amount, not both!")
//                       );
//                     }
//                     if (value == null && discPer == null) {
//                       return Promise.reject(
//                         new Error("Please enter either discount percentage or amount!")
//                       );
//                     }
//                     return Promise.resolve();
//                   },
//                 }),
//               ]}
//             >
//               <InputNumber
//                 placeholder="Enter discount amount"
//                 style={{ width: "100%" }}
//               />
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="amcPeriod"
//               label="AMC Period"
//               rules={[
//                 { required: true, message: "Please enter the AMC period!" },
//               ]}
//             >
//               <InputNumber
//                 placeholder="Enter period in months"
//                 style={{ width: "100%" }}
//               />
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="durType"
//               label="Dur Type"
//               rules={[
//                 {
//                   required: true,
//                   message: "Please select at least one Dur Type!",
//                 },
//               ]}
//             >
//               <Select
//                 placeholder="Select Type"
//                 style={{ width: "100%" }}
//                 allowClear
//                 showSearch
//                 filterOption={(input, option) =>
//                   option.children.toLowerCase().indexOf(input.toLowerCase()) >=
//                   0
//                 }
//               >
//                 {dueTypeOptions.map((product) => (
//                   <Select.Option key={product.id} value={product.id}>
//                     {product.name}
//                   </Select.Option>
//                 ))}
//               </Select>
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="amcPrice"
//               label="AMC Price"
//               rules={[
//                 { required: true, message: "Please enter the AMC price!" },
//               ]}
//             >
//               <InputNumber
//                 placeholder="Enter AMC price"
//                 style={{ width: "100%" }}
//               />
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="detail"
//               label="Detail"
//               rules={[{ required: true, message: "Please enter the detail!" }]}
//             >
//               <Input placeholder="Enter details" />
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="isDemo"
//               label="Demo"
//               rules={[
//                 { required: true, message: "Please specify if it is a demo!" },
//               ]}
//             >
//               <Select placeholder="Select">
//                 <Select.Option value={1}>Yes</Select.Option>
//                 <Select.Option value={0}>No</Select.Option>
//               </Select>
//             </Form.Item>
//           </Col>

//           <Col span={6}>
//             <Form.Item
//               name="businessType"
//               label="Business Type"
//               rules={[
//                 { required: true, message: "Please select a Business Type!" },
//               ]}
//             >
//               <Select
//                 placeholder="Select Business Type"
//                 onChange={handleBusinessChange}
//                 value={selectedBusinessType}
//               >
//                 {businessType.map(({ id, type }) => (
//                   <Select.Option key={id} value={id}>
//                     {type}
//                   </Select.Option>
//                 ))}
//               </Select>
//             </Form.Item>
//           </Col>

//           {/* <Col span={12}>
//             <Form.Item
//               name="product"
//               label="Products"
//               rules={[
//                 {
//                   required: true,
//                   message: "Please select at least one product!",
//                 },
//                 {
//                   type: "array",
//                   min: 1,
//                   message: "Please select at least one product!",
//                 },
//               ]}
//             >
//               <Select
//                 mode="multiple"
//                 placeholder="Select Products"
//                 style={{ width: "100%" }}
//                 allowClear
//                 showSearch
//                 filterOption={(input, option) =>
//                   option.children.toLowerCase().indexOf(input.toLowerCase()) >=
//                   0
//                 }
//               >
//                 {productOptions.map((product) => (
//                   <Select.Option key={product.id} value={product.id}>
//                     {product.name}
//                   </Select.Option>
//                 ))}
//               </Select>
//             </Form.Item>
//           </Col> */}

//           <Col span={6}>
//             <Form.Item name="isReferralPer" label="Referral Per">
//               <Switch onChange={(e) => setIsReferralPer(e)} />
//             </Form.Item>
//           </Col>

//           {isReferralPer ? (
//             <Col span={6}>
//               <Form.Item name="referralAmt" label="Referral Amount">
//                 <InputNumber
//                   placeholder="Enter Referral Amt"
//                   style={{ width: "100%" }}
//                 />
//               </Form.Item>
//             </Col>
//           ) : (
//             <Col span={6}>
//               <Form.Item name="referralPer" label="Referral Per">
//                 <InputNumber
//                   placeholder="Enter Referral Per"
//                   style={{ width: "100%" }}
//                 />
//               </Form.Item>
//             </Col>
//           )}

//           {/* <Col span={4}>
//             <Form.Item label="Unlimited Companies">
//               <Switch
//                 checked={unlimitedFields.noOfCompanies}
//                 onChange={(checked) => {
//                   setUnlimitedFields((prev) => ({
//                     ...prev,
//                     noOfCompanies: checked,
//                   }));
//                   if (unlimitedFields.noOfCompanies)
//                     form.setFieldValue("noOfCompanies", "");
//                   else form.setFieldValue("noOfCompanies", "Unlimited");
//                 }}
//               />
//             </Form.Item>
//           </Col> */}
//           <Col span={4}>
//             <Form.Item label="No Of Companies" required>
//               <Flex gap="middle" justify="start" align="center">
//                 {unlimitedFields.noOfCompanies ? (
//                   <Input
//                     placeholder="Unlimited"
//                     style={{ width: "100%" }}
//                     value="Unlimited"
//                     disabled
//                   />
//                 ) : (
//                   <Form.Item
//                     name="noOfCompanies"
//                     noStyle
//                     rules={[
//                       { required: true, message: "Please enter number!" },
//                     ]}
//                   >
//                     <InputNumber
//                       placeholder="Enter No Of Companies"
//                       style={{ width: "100%" }}
//                       min={1}
//                     />
//                   </Form.Item>
//                 )}
//                 <Switch
//                   checked={unlimitedFields.noOfCompanies}
//                   checkedChildren={
//                     <Infinity
//                       width={20}
//                       style={{ paddingBottom: "3px", marginRight: "40px" }}
//                     />
//                   }
//                   onChange={(checked) => {
//                     setUnlimitedFields((prev) => ({
//                       ...prev,
//                       noOfCompanies: checked,
//                     }));
//                     if (checked) {
//                       form.setFieldsValue({ noOfCompanies: undefined });
//                     }
//                   }}
//                 />
//               </Flex>
//             </Form.Item>
//           </Col>

//           {/* <Col span={4}>
//             <Form.Item label="Unlimited Eways">
//               <Switch
//                 checked={unlimitedFields.noOfEways}
//                 onChange={(checked) => {
//                   setUnlimitedFields((prev) => ({
//                     ...prev,
//                     noOfEways: checked,
//                   }));
//                   if (unlimitedFields.noOfEways)
//                     form.setFieldValue("noOfEways", "");
//                   else form.setFieldValue("noOfEways", "Unlimited");
//                 }}
//               />
//             </Form.Item>
//           </Col> */}
//           <Col span={4}>
//             <Form.Item label="No Of Eways" required>
//               <Flex gap="middle" justify="start" align="center">
//                 {unlimitedFields.noOfEways ? (
//                   <Input
//                     placeholder="Unlimited"
//                     style={{ width: "100%" }}
//                     value="Unlimited"
//                     disabled
//                   />
//                 ) : (
//                   <Form.Item
//                     name="noOfEways"
//                     noStyle
//                     rules={[
//                       { required: true, message: "Please enter number!" },
//                     ]}
//                   >
//                     <InputNumber
//                       placeholder="Enter No Of Eways"
//                       style={{ width: "100%" }}
//                       min={1}
//                     />
//                   </Form.Item>
//                 )}
//                 <Switch
//                   checked={unlimitedFields.noOfEways}
//                   checkedChildren={
//                     <Infinity
//                       width={20}
//                       style={{ paddingBottom: "3px", marginRight: "40px" }}
//                     />
//                   }
//                   onChange={(checked) => {
//                     setUnlimitedFields((prev) => ({
//                       ...prev,
//                       noOfEways: checked,
//                     }));
//                     if (checked) {
//                       form.setFieldsValue({ noOfEways: undefined });
//                     }
//                   }}
//                 />
//               </Flex>
//             </Form.Item>
//           </Col>

//           {/* <Col span={4}>
//             <Form.Item label="Unlimited EInvoice">
//               <Switch
//                 checked={unlimitedFields.noOfEInvoice}
//                 onChange={(checked) => {
//                   setUnlimitedFields((prev) => ({
//                     ...prev,
//                     noOfEInvoice: checked,
//                   }));
//                   if (unlimitedFields.noOfEInvoice)
//                     form.setFieldValue("noOfEInvoice", "");
//                   else form.setFieldValue("noOfEInvoice", "Unlimited");
//                 }}
//               />
//             </Form.Item>
//           </Col> */}
//           <Col span={4}>
//             <Form.Item label="No Of EInvoice" required>
//               <Flex gap="middle" justify="start" align="center">
//                 {unlimitedFields.noOfEInvoice ? (
//                   <Input
//                     placeholder="Unlimited"
//                     style={{ width: "100%" }}
//                     value="Unlimited"
//                     disabled
//                   />
//                 ) : (
//                   <Form.Item
//                     name="noOfEInvoice"
//                     noStyle
//                     rules={[
//                       { required: true, message: "Please enter number!" },
//                     ]}
//                   >
//                     <InputNumber
//                       placeholder="Enter No Of EInvoice"
//                       style={{ width: "100%" }}
//                       min={1}
//                     />
//                   </Form.Item>
//                 )}
//                 <Switch
//                   checked={unlimitedFields.noOfEInvoice}
//                   checkedChildren={
//                     <Infinity
//                       width={20}
//                       style={{ paddingBottom: "3px", marginRight: "40px" }}
//                     />
//                   }
//                   onChange={(checked) => {
//                     setUnlimitedFields((prev) => ({
//                       ...prev,
//                       noOfEInvoice: checked,
//                     }));
//                     if (checked) {
//                       form.setFieldsValue({ noOfEInvoice: undefined });
//                     }
//                   }}
//                 />
//               </Flex>
//             </Form.Item>
//           </Col>

//           {/* <Col span={4}>
//             <Form.Item label="Unlimited User">
//               <Switch
//                 checked={unlimitedFields.noOfUser}
//                 onChange={(checked) => {
//                   setUnlimitedFields((prev) => ({
//                     ...prev,
//                     noOfUser: checked,
//                   }));
//                   if (unlimitedFields.noOfUser)
//                     form.setFieldValue("noOfUser", "");
//                   else form.setFieldValue("noOfUser", "Unlimited");
//                 }}
//               />
//             </Form.Item>
//           </Col> */}
//           <Col span={4}>
//             <Form.Item label="No Of User" required>
//               <Flex gap="middle" justify="start" align="center">
//                 {unlimitedFields.noOfUser ? (
//                   <Input
//                     placeholder="Unlimited"
//                     style={{ width: "100%" }}
//                     value="Unlimited"
//                     disabled
//                   />
//                 ) : (
//                   <Form.Item
//                     name="noOfUser"
//                     noStyle
//                     rules={[
//                       { required: true, message: "Please enter number!" },
//                     ]}
//                   >
//                     <InputNumber
//                       placeholder="Enter No Of User"
//                       style={{ width: "100%" }}
//                       min={1}
//                     />
//                   </Form.Item>
//                 )}
//                 <Switch
//                   checked={unlimitedFields.noOfUser}
//                   checkedChildren={
//                     <Infinity
//                       width={20}
//                       style={{ paddingBottom: "3px", marginRight: "40px" }}
//                     />
//                   }
//                   onChange={(checked) => {
//                     setUnlimitedFields((prev) => ({
//                       ...prev,
//                       noOfUser: checked,
//                     }));
//                     if (checked) {
//                       form.setFieldsValue({ noOfUser: undefined });
//                     }
//                   }}
//                 />
//               </Flex>
//             </Form.Item>
//           </Col>

//           {/* <Col span={4}>
//             <Form.Item label="Unlimited WP">
//               <Switch
//                 checked={unlimitedFields.noOfWp}
//                 onChange={(checked) => {
//                   setUnlimitedFields((prev) => ({ ...prev, noOfWp: checked }));
//                   if (unlimitedFields.noOfWp) form.setFieldValue("noOfWp", "");
//                   else form.setFieldValue("noOfWp", "Unlimited");
//                 }}
//               />
//             </Form.Item>
//           </Col> */}

//           <Col span={4}>
//             <Form.Item label="No Of Wp" required>
//               <Flex gap="middle" justify="start" align="center">
//                 {unlimitedFields.noOfWp ? (
//                   <Input
//                     placeholder="Unlimited"
//                     style={{ width: "100%" }}
//                     value="Unlimited"
//                     disabled
//                   />
//                 ) : (
//                   <Form.Item
//                     name="noOfWp"
//                     noStyle
//                     rules={[
//                       { required: true, message: "Please enter number!" },
//                     ]}
//                   >
//                     <InputNumber
//                       placeholder="Enter No Of Wp"
//                       style={{ width: "100%" }}
//                       min={1}
//                     />
//                   </Form.Item>
//                 )}
//                 <Switch
//                   checked={unlimitedFields.noOfWp}
//                   checkedChildren={
//                     <Infinity
//                       width={20}
//                       style={{ paddingBottom: "3px", marginRight: "40px" }}
//                     />
//                   }
//                   onChange={(checked) => {
//                     setUnlimitedFields((prev) => ({
//                       ...prev,
//                       noOfWp: checked,
//                     }));
//                     if (checked) {
//                       form.setFieldsValue({ noOfWp: undefined });
//                     }
//                   }}
//                 />
//               </Flex>
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="sales_invoice" label="Sales Invoice">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="sales_order" label="Sales Order">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="sales_challan" label="Sales Challan">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="sales_return" label="Sales Return">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="purchase_invoice" label="Purchase Invoice">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="purchase_order" label="Purchase Order">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="purchase_challan" label="Purchase Challan">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="purchase_return" label="Purchase Return">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="issue" label="Issue">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="receive" label="Receive">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="cash" label="Cash">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="bank" label="Bank">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="jv" label="JV">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="share_company" label="Share Company">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="stock_transfer" label="Stock Transfer">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="company_wise_master" label="Company Wish Master">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="delete_unused_master" label="Delete Unused Master">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="print_barcode" label="Print Barcode">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="isMobileApp" label="Mobile App">
//               <Switch />
//             </Form.Item>
//           </Col>
//           <Col span={4}>
//             <Form.Item name="isCrm" label="Crm">
//               <Switch />
//             </Form.Item>
//           </Col>
//           <Col span={4}>
//             <Form.Item name="isRojmel" label="Rojmel">
//               <Switch />
//             </Form.Item>
//           </Col>
//           <Col span={4}>
//             <Form.Item name="isToDo" label="ToDo">
//               <Switch />
//             </Form.Item>
//           </Col>
//           <Col span={4}>
//             <Form.Item name="isDailyWp" label="Daily Wp">
//               <Switch />
//             </Form.Item>
//           </Col>
//           <Col span={4}>
//             <Form.Item name="is2a2b" label="2A2B">
//               <Switch />
//             </Form.Item>
//           </Col>
//           <Col span={4}>
//             <Form.Item name="isDashboardGst" label="Dashboard Gst">
//               <Switch />
//             </Form.Item>
//           </Col>
//           <Col span={4}>
//             <Form.Item name="is2stepVerify" label="Two Step Verify">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item name="bank_import" label="Bank Import">
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item
//               name="aamne_saamne_sale_purchase"
//               label="Aamne - Saamne Sale Purchase"
//             >
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item
//               name="multiple_eway_bill_generate"
//               label="Multiple Eway Bill Generate"
//             >
//               <Switch />
//             </Form.Item>
//           </Col>

//           <Col span={4}>
//             <Form.Item
//               name="bulk_update_suspense_account"
//               label="Bulk Update Suspense Account"
//             >
//               <Switch />
//             </Form.Item>
//           </Col>
//         </Row>
//       </Form>
//     </Modal>
//   );
// };

// export default PackageForm;


import { useState, useEffect, useRef, useCallback } from "react";
import { Infinity } from "lucide-react";

const PackageForm = ({ visible, onCreate, onCancel, record, businessType }) => {
  const [activeTab, setActiveTab] = useState("basic");
  const [selectedBusinessType, setSelectedBusinessType] = useState(null);
  const [isReferralPer, setIsReferralPer] = useState(true);
  const [unlimitedFields, setUnlimitedFields] = useState({
    noOfCompanies: false,
    noOfEways: false,
    noOfEInvoice: false,
    noOfUser: false,
    noOfWp: false,
  });
  const [formValues, setFormValues] = useState({});
  const [errors, setErrors] = useState({});
  const formRef = useRef(null);

  const dueTypeOptions = [
    { id: "DAY", name: "Day" },
    { id: "MONTH", name: "Month" },
    { id: "YEAR", name: "Year" },
  ];

  const tabs = [
    { key: "basic", label: "Basic Info" },
    { key: "pricing", label: "Pricing & AMC" },
    { key: "limits", label: "Limits" },
    { key: "transactions", label: "Transactions" },
    { key: "features", label: "Features" },
  ];

  useEffect(() => {
    if (record) {
      const isDemoValue =
        record.isDemo === true || record.isDemo === 1 || record.isDemo === "1"
          ? 1
          : 0;
      const unlimitedState = {
        noOfCompanies: record.noOfCompanies === -100,
        noOfEways: record.noOfEways === -100,
        noOfEInvoice: record.noOfEInvoice === -100,
        noOfUser: record.noOfUser === -100,
        noOfWp: record.noOfWp === -100,
      };
      setUnlimitedFields(unlimitedState);
      setSelectedBusinessType(record.businessType);
      setFormValues({
        name: record.name || "",
        description: record.description || "",
        discPer: record.discPer || "",
        discAmt: record.discAmt || "",
        amcPeriod: record.amcPeriod || "",
        durType: record.durType || "",
        amcPrice: record.amcPrice || "",
        detail: record.detail || "",
        isDemo: isDemoValue,
        businessType: record.businessType || "",
        product: [1],
        noOfCompanies: unlimitedState.noOfCompanies ? "" : record.noOfCompanies || "",
        noOfEways: unlimitedState.noOfEways ? "" : record.noOfEways || "",
        noOfEInvoice: unlimitedState.noOfEInvoice ? "" : record.noOfEInvoice || "",
        noOfUser: unlimitedState.noOfUser ? "" : record.noOfUser || "",
        noOfWp: unlimitedState.noOfWp ? "" : record.noOfWp || "",
        isMobileApp: record.isMobileApp || false,
        isCrm: record.isCrm || false,
        isRojmel: record.isRojmel || false,
        isToDo: record.isToDo || false,
        isDailyWp: record.isDailyWp || false,
        referralAmt: record.referralAmt || "",
        referralPer: record.referralPer || "",
        isDashboardGst: record.isDashboardGst || false,
        is2a2b: record.is2a2b || false,
        is2stepVerify: record.is2stepVerify || false,
        sales_challan: record.sales_challan || false,
        sales_invoice: record.sales_invoice || false,
        purchase_challan: record.purchase_challan || false,
        purchase_invoice: record.purchase_invoice || false,
        sales_return: record.sales_return || false,
        purchase_return: record.purchase_return || false,
        issue: record.issue || false,
        receive: record.receive || false,
        cash: record.cash || false,
        bank: record.bank || false,
        jv: record.jv || false,
        stock_transfer: record.stock_transfer || false,
        share_company: record.share_company || false,
        company_wise_master: record.company_wise_master || false,
        delete_unused_master: record.delete_unused_master || false,
        aamne_saamne_sale_purchase: record.aamne_saamne_sale_purchase || false,
        multiple_eway_bill_generate: record.multiple_eway_bill_generate || false,
        print_barcode: record.print_barcode || false,
        sales_order: record.sales_order || false,
        purchase_order: record.purchase_order || false,
        bank_import: record.bank_import || false,
        bulk_update_suspense_account: record.bulk_update_suspense_account || false,
      });
    } else {
      resetForm();
    }
  }, [record]);

  const resetForm = () => {
    setFormValues({});
    setErrors({});
    setSelectedBusinessType(null);
    setActiveTab("basic");
    setIsReferralPer(true);
    setUnlimitedFields({
      noOfCompanies: false,
      noOfEways: false,
      noOfEInvoice: false,
      noOfUser: false,
      noOfWp: false,
    });
  };

  const handleChange = (name, value) => {
    setFormValues((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formValues.name) newErrors.name = "Package name is required!";
    if (!formValues.description) newErrors.description = "Description is required!";
    if (!formValues.detail) newErrors.detail = "Detail is required!";
    if (!formValues.isDemo && formValues.isDemo !== 0) newErrors.isDemo = "Please specify if it is a demo!";
    if (!formValues.businessType) newErrors.businessType = "Business type is required!";

    const discPer = formValues.discPer !== "" && formValues.discPer != null;
    const discAmt = formValues.discAmt !== "" && formValues.discAmt != null;
    if (discPer && discAmt) {
      newErrors.discPer = "Enter either percentage OR amount, not both!";
      newErrors.discAmt = "Enter either percentage OR amount, not both!";
    } else if (!discPer && !discAmt) {
      newErrors.discPer = "Please enter either discount percentage or amount!";
      newErrors.discAmt = "Please enter either discount percentage or amount!";
    }

    if (!formValues.amcPeriod) newErrors.amcPeriod = "AMC period is required!";
    if (!formValues.durType) newErrors.durType = "Duration type is required!";
    if (!formValues.amcPrice) newErrors.amcPrice = "AMC price is required!";

    ["noOfCompanies", "noOfEways", "noOfEInvoice", "noOfUser", "noOfWp"].forEach((f) => {
      if (!unlimitedFields[f] && !formValues[f]) {
        newErrors[f] = "Please enter a number!";
      }
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      const basicFields = ["name", "description", "detail", "isDemo", "businessType"];
      const pricingFields = ["discPer", "discAmt", "amcPeriod", "durType", "amcPrice"];
      const limitFields = ["noOfCompanies", "noOfEways", "noOfEInvoice", "noOfUser", "noOfWp"];
      if (basicFields.some((f) => newErrors[f])) setActiveTab("basic");
      else if (pricingFields.some((f) => newErrors[f])) setActiveTab("pricing");
      else if (limitFields.some((f) => newErrors[f])) setActiveTab("limits");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    const values = { ...formValues };
    values.isDemo = values.isDemo === 1 ? true : false;

    ["noOfCompanies", "noOfEways", "noOfEInvoice", "noOfUser", "noOfWp"].forEach((field) => {
      if (unlimitedFields[field]) {
        values[field] = -100;
      } else if (values[field] === undefined || values[field] === null || values[field] === "") {
        values[field] = 0;
      } else {
        values[field] = Number(values[field]);
      }
    });

    onCreate(values);
    resetForm();
  };

  const handleCancel = () => {
    resetForm();
    onCancel();
  };

  // Enter key: move focus to next focusable input/select in tab
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key !== "Enter") return;
      const tag = e.target.tagName;
      if (tag !== "INPUT" && tag !== "SELECT") return;

      const focusable = Array.from(
        formRef.current?.querySelectorAll(
          `#tab-${activeTab} input:not([disabled]), #tab-${activeTab} select`
        ) || []
      ).filter((el) => el.offsetParent !== null);

      const idx = focusable.indexOf(e.target);
      if (idx >= 0 && idx < focusable.length - 1) {
        e.preventDefault();
        focusable[idx + 1].focus();
      } else if (idx === focusable.length - 1) {
        const nextTabIdx = tabs.findIndex((t) => t.key === activeTab) + 1;
        if (nextTabIdx < tabs.length) {
          e.preventDefault();
          setActiveTab(tabs[nextTabIdx].key);
          setTimeout(() => {
            const nextFocusable = formRef.current?.querySelectorAll(
              `#tab-${tabs[nextTabIdx].key} input:not([disabled]), #tab-${tabs[nextTabIdx].key} select`
            );
            if (nextFocusable?.length) nextFocusable[0].focus();
          }, 50);
        }
      }
    },
    [activeTab, tabs]
  );

  if (!visible) return null;

  const inputClass = (field) =>
    `form-control form-control-sm${errors[field] ? " is-invalid" : ""}`;

  const selectClass = (field) =>
    `form-select form-select-sm${errors[field] ? " is-invalid" : ""}`;

  const SwitchField = ({ name, label }) => (
    <div className="col-md-4 col-6 mb-2">
      <div className="d-flex align-items-center justify-content-between border rounded px-3 py-2 h-100" style={{ minHeight: 42 }}>
        <label className="form-label mb-0 fw-medium" style={{ fontSize: 13 }}>
          {label}
        </label>
        <div className="form-check form-switch mb-0 ms-2">
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={!!formValues[name]}
            onChange={(e) => handleChange(name, e.target.checked)}
          />
        </div>
      </div>
    </div>
  );

  const UnlimitedField = ({ field, label, tabIndex }) => (
    <div className="col-md-4 col-6 mb-3">
      <label className="form-label fw-medium" style={{ fontSize: 12 }}>
        {label} <span className="text-danger">*</span>
      </label>
      <div className="input-group input-group-sm">
        <input
          type="number"
          className={`form-control${errors[field] ? " is-invalid" : ""}`}
          placeholder={unlimitedFields[field] ? "Unlimited" : "Enter count"}
          value={unlimitedFields[field] ? "" : formValues[field] || ""}
          disabled={unlimitedFields[field]}
          min={1}
          tabIndex={tabIndex}
          onChange={(e) => handleChange(field, e.target.value)}
        />
        <button
          type="button"
          className={`btn btn-sm ${unlimitedFields[field] ? "btn-primary" : "btn-outline-secondary"}`}
          title="Toggle unlimited"
          onClick={() => {
            setUnlimitedFields((prev) => ({ ...prev, [field]: !prev[field] }));
            if (!unlimitedFields[field]) handleChange(field, "");
          }}
        >
          <Infinity size={16} />
        </button>
        {errors[field] && <div className="invalid-feedback">{errors[field]}</div>}
      </div>
    </div>
  );

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.45)", zIndex: 10000 }}
      tabIndex={-1}
    >
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content" ref={formRef} onKeyDown={handleKeyDown}>
          {/* Header */}
          <div className="modal-header py-3">
            <h5 className="modal-title fw-semibold">
              {record ? "Update Package" : "Add Package"}
            </h5>
            <button type="button" className="btn-close" onClick={handleCancel} />
          </div>

          {/* Tabs */}
          <div className="modal-body pt-0 pb-0">
            <ul className="nav nav-tabs mt-3" role="tablist">
              {tabs.map((tab) => (
                <li className="nav-item" key={tab.key}>
                  <button
                    className={`nav-link${activeTab === tab.key ? " active" : ""}`}
                    style={{ fontSize: 13 }}
                    onClick={() => setActiveTab(tab.key)}
                    type="button"
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>

            <div className="tab-content pt-3 pb-2" style={{ minHeight: 380 }}>

              {/* ── Tab 1: Basic Info ── */}
              <div id="tab-basic" className={`tab-pane${activeTab === "basic" ? " show active" : ""}`}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={inputClass("name")}
                      placeholder="Enter package name"
                      value={formValues.name || ""}
                      tabIndex={1}
                      onChange={(e) => handleChange("name", e.target.value)}
                    />
                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      Description <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={inputClass("description")}
                      placeholder="Enter description"
                      value={formValues.description || ""}
                      tabIndex={2}
                      onChange={(e) => handleChange("description", e.target.value)}
                    />
                    {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                  </div>

                  <div className="col-md-6">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      Detail <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={inputClass("detail")}
                      placeholder="Enter details"
                      value={formValues.detail || ""}
                      tabIndex={3}
                      onChange={(e) => handleChange("detail", e.target.value)}
                    />
                    {errors.detail && <div className="invalid-feedback">{errors.detail}</div>}
                  </div>

                  <div className="col-md-3">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      Business Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className={selectClass("businessType")}
                      value={formValues.businessType || ""}
                      tabIndex={4}
                      onChange={(e) => {
                        handleChange("businessType", e.target.value);
                        setSelectedBusinessType(e.target.value);
                      }}
                    >
                      <option value="">Select Business Type</option>
                      {businessType.map(({ id, type }) => (
                        <option key={id} value={id}>{type}</option>
                      ))}
                    </select>
                    {errors.businessType && <div className="invalid-feedback">{errors.businessType}</div>}
                  </div>

                  <div className="col-md-3">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      Demo <span className="text-danger">*</span>
                    </label>
                    <select
                      className={selectClass("isDemo")}
                      value={formValues.isDemo ?? ""}
                      tabIndex={5}
                      onChange={(e) => handleChange("isDemo", Number(e.target.value))}
                    >
                      <option value="">Select</option>
                      <option value={1}>Yes</option>
                      <option value={0}>No</option>
                    </select>
                    {errors.isDemo && <div className="invalid-feedback">{errors.isDemo}</div>}
                  </div>

                  {/* Referral */}
                  <div className="col-12">
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <span className="fw-medium" style={{ fontSize: 12 }}>Referral Type:</span>
                      <div className="btn-group btn-group-sm">
                        <button
                          type="button"
                          className={`btn ${isReferralPer ? "btn-primary" : "btn-outline-secondary"}`}
                          onClick={() => setIsReferralPer(true)}
                        >
                          Amount
                        </button>
                        <button
                          type="button"
                          className={`btn ${!isReferralPer ? "btn-primary" : "btn-outline-secondary"}`}
                          onClick={() => setIsReferralPer(false)}
                        >
                          Percentage
                        </button>
                      </div>
                    </div>
                  </div>

                  {isReferralPer ? (
                    <div className="col-md-3">
                      <label className="form-label fw-medium" style={{ fontSize: 12 }}>Referral Amount</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter amount"
                        value={formValues.referralAmt || ""}
                        tabIndex={6}
                        onChange={(e) => handleChange("referralAmt", e.target.value)}
                      />
                    </div>
                  ) : (
                    <div className="col-md-3">
                      <label className="form-label fw-medium" style={{ fontSize: 12 }}>Referral Percentage</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        placeholder="Enter %"
                        value={formValues.referralPer || ""}
                        tabIndex={6}
                        onChange={(e) => handleChange("referralPer", e.target.value)}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* ── Tab 2: Pricing & AMC ── */}
              <div id="tab-pricing" className={`tab-pane${activeTab === "pricing" ? " show active" : ""}`}>
                <div className="alert alert-info py-2 px-3 mb-3" style={{ fontSize: 12 }}>
                  Enter either Discount % <strong>or</strong> Discount Amount — not both.
                </div>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>Discount (%)</label>
                    <input
                      type="number"
                      className={inputClass("discPer")}
                      placeholder="Enter %"
                      value={formValues.discPer || ""}
                      tabIndex={10}
                      onChange={(e) => {
                        handleChange("discPer", e.target.value);
                        if (e.target.value) handleChange("discAmt", "");
                      }}
                    />
                    {errors.discPer && <div className="invalid-feedback">{errors.discPer}</div>}
                  </div>

                  <div className="col-md-3">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>Discount Amount</label>
                    <input
                      type="number"
                      className={inputClass("discAmt")}
                      placeholder="Enter amount"
                      value={formValues.discAmt || ""}
                      tabIndex={11}
                      onChange={(e) => {
                        handleChange("discAmt", e.target.value);
                        if (e.target.value) handleChange("discPer", "");
                      }}
                    />
                    {errors.discAmt && <div className="invalid-feedback">{errors.discAmt}</div>}
                  </div>

                  <div className="col-md-2">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      AMC Period <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className={inputClass("amcPeriod")}
                      placeholder="Months"
                      value={formValues.amcPeriod || ""}
                      tabIndex={12}
                      onChange={(e) => handleChange("amcPeriod", e.target.value)}
                    />
                    {errors.amcPeriod && <div className="invalid-feedback">{errors.amcPeriod}</div>}
                  </div>

                  <div className="col-md-2">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      Duration Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className={selectClass("durType")}
                      value={formValues.durType || ""}
                      tabIndex={13}
                      onChange={(e) => handleChange("durType", e.target.value)}
                    >
                      <option value="">Select</option>
                      {dueTypeOptions.map((o) => (
                        <option key={o.id} value={o.id}>{o.name}</option>
                      ))}
                    </select>
                    {errors.durType && <div className="invalid-feedback">{errors.durType}</div>}
                  </div>

                  <div className="col-md-2">
                    <label className="form-label fw-medium" style={{ fontSize: 12 }}>
                      AMC Price <span className="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      className={inputClass("amcPrice")}
                      placeholder="Enter price"
                      value={formValues.amcPrice || ""}
                      tabIndex={14}
                      onChange={(e) => handleChange("amcPrice", e.target.value)}
                    />
                    {errors.amcPrice && <div className="invalid-feedback">{errors.amcPrice}</div>}
                  </div>
                </div>
              </div>

              {/* ── Tab 3: Limits ── */}
              <div id="tab-limits" className={`tab-pane${activeTab === "limits" ? " show active" : ""}`}>
                <p className="text-muted mb-3" style={{ fontSize: 12 }}>
                  Click ∞ to toggle unlimited access for a field.
                </p>
                <div className="row">
                  <UnlimitedField field="noOfCompanies" label="No. of Companies" tabIndex={20} />
                  <UnlimitedField field="noOfEways" label="No. of Eways" tabIndex={21} />
                  <UnlimitedField field="noOfEInvoice" label="No. of E-Invoice" tabIndex={22} />
                  <UnlimitedField field="noOfUser" label="No. of Users" tabIndex={23} />
                  <UnlimitedField field="noOfWp" label="No. of WP" tabIndex={24} />
                </div>
              </div>

              {/* ── Tab 4: Transactions ── */}
              <div id="tab-transactions" className={`tab-pane${activeTab === "transactions" ? " show active" : ""}`}>
                <p className="text-muted mb-3" style={{ fontSize: 12 }}>
                  Enable the transaction types available in this package.
                </p>
                <div className="row g-2">
                  <SwitchField name="sales_invoice" label="Sales Invoice" />
                  <SwitchField name="sales_order" label="Sales Order" />
                  <SwitchField name="sales_challan" label="Sales Challan" />
                  <SwitchField name="sales_return" label="Sales Return" />
                  <SwitchField name="purchase_invoice" label="Purchase Invoice" />
                  <SwitchField name="purchase_order" label="Purchase Order" />
                  <SwitchField name="purchase_challan" label="Purchase Challan" />
                  <SwitchField name="purchase_return" label="Purchase Return" />
                  <SwitchField name="issue" label="Issue" />
                  <SwitchField name="receive" label="Receive" />
                  <SwitchField name="cash" label="Cash" />
                  <SwitchField name="bank" label="Bank" />
                  <SwitchField name="jv" label="JV" />
                  <SwitchField name="stock_transfer" label="Stock Transfer" />
                  <SwitchField name="share_company" label="Share Company" />
                  <SwitchField name="bank_import" label="Bank Import" />
                </div>
              </div>

              {/* ── Tab 5: Features ── */}
              <div id="tab-features" className={`tab-pane${activeTab === "features" ? " show active" : ""}`}>
                <p className="text-muted mb-3" style={{ fontSize: 12 }}>
                  Enable advanced features included in this package.
                </p>
                <div className="row g-2">
                  <SwitchField name="isMobileApp" label="Mobile App" />
                  <SwitchField name="isCrm" label="CRM" />
                  <SwitchField name="isRojmel" label="Rojmel" />
                  <SwitchField name="isToDo" label="To Do" />
                  <SwitchField name="isDailyWp" label="Daily WP" />
                  <SwitchField name="is2a2b" label="2A2B" />
                  <SwitchField name="isDashboardGst" label="Dashboard GST" />
                  <SwitchField name="is2stepVerify" label="Two-Step Verify" />
                  <SwitchField name="company_wise_master" label="Company Wise Master" />
                  <SwitchField name="delete_unused_master" label="Delete Unused Master" />
                  <SwitchField name="print_barcode" label="Print Barcode" />
                  <SwitchField name="aamne_saamne_sale_purchase" label="Aamne Saamne Sale Purchase" />
                  <SwitchField name="multiple_eway_bill_generate" label="Multiple Eway Bill Generate" />
                  <SwitchField name="bulk_update_suspense_account" label="Bulk Update Suspense Account" />
                </div>
              </div>

            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer py-2">
            <button
              type="button"
              className="btn btn-secondary btn-sm px-4"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary btn-sm px-4"
              onClick={handleSubmit}
            >
              {record ? "Update" : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageForm;